
function Footer() {
    return (
        <div className="main-footer">DEGREE APPRENTICE HUB&nbsp;&#169;&nbsp;2024</div>
    )
}


export default Footer;